import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PagedList } from "../../../app/model/domain/PagedList";
import { UploadRv } from "../../../app/model/domain/UploadRv";
import {
  VariableIncome,
  VariableIncomeRowItem,
} from "../../../app/model/domain/VariableIncome";
import { environment } from "../../../environments/environment";
import { FilterDateType } from "./../../model/domain/MonitorFilter";
import { ITicketableService, StatusDetails } from "./ITicketableService";

@Injectable({
  providedIn: "root",
})
export class VariableIncomeService
  implements ITicketableService<VariableIncome>
{
  private readonly name = "variable-income";

  constructor(private http: HttpClient) {}

  registerTicket(ticket: VariableIncome) {
    return this.http.post(
      `${environment.apiUrls.tickets}/${this.name}/`,
      ticket
    );
  }

  updateTicket(id: number, ticket: VariableIncome) {
    return this.http.put(
      `${environment.apiUrls.tickets}/${this.name}/${id}`,
      ticket
    );
  }

  duplicateTicket(id: number) {
    return this.http.post(
      `${environment.apiUrls.tickets}/${this.name}/${id}/duplicate`,
      {}
    );
  }

  getTicket(id: number) {
    return this.getTicketPaged(id, 1, 10);
  }

  getTicketPaged(id: number, page: number, pageSize: number) {
    const url = `${environment.apiUrls.tickets}/${this.name}/${id}`;

    const params: any = {};
    if (page != null) {
      params.page = page;
    }

    if (pageSize != null) {
      params.pageSize = pageSize;
    }

    return this.http.get<VariableIncome>(url, {
      params,
    });
  }

  listTicket(
    dateType: FilterDateType = null,
    startDate: Date = null,
    endDate: Date = null,
    statusId: number = null,
    operationTypeId: number = null,
    settlementTypeId: number = null,
    portfolioCode: string = null,
    portfolioName: string = null,
    portfolioDocument: string = null,
    ticketId: number = null,
    accountManagerId: number = null,
    page: number = null,
    pageSize: number = null,
    isOutstanding: boolean = false
  ) {
    const params: any = { isOutstanding: isOutstanding };

    if (dateType) {
      params.dateType = dateType;
    }

    if (startDate) {
      params.startDate = startDate.toJSON();
    }

    if (endDate) {
      params.endDate = endDate.toJSON();
    }

    if (statusId) {
      params.statusId = statusId.toString();
    }

    if (operationTypeId) {
      params.operationTypeId = operationTypeId;
    }

    if (settlementTypeId) {
      params.settlementTypeId = settlementTypeId;
    }

    if (portfolioCode) {
      params.portfolioCode = portfolioCode;
    }

    if (portfolioName) {
      params.portfolioName = portfolioName;
    }

    if (portfolioDocument) {
      params.portfolioDocument = portfolioDocument;
    }

    if (ticketId) {
      params.ticketId = ticketId;
    }

    if (accountManagerId) {
      params.accountManagerId = accountManagerId;
    }

    if (page) {
      params.page = page;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    return this.http.get<PagedList<VariableIncome>>(
      `${environment.apiUrls.tickets}/${this.name}/list-paginated`,
      {
        params,
      }
    );
  }

  listTicketItemsById(id: number, page: number, pageSize: number) {
    const url = `${environment.apiUrls.tickets}/${this.name}/${id}/items`;

    const params: any = {};

    if (page != null) {
      params.page = page;
    }

    if (pageSize != null) {
      params.pageSize = pageSize;
    }

    return this.http.get<PagedList<VariableIncomeRowItem>>(url, {
      params,
    });
  }

  forwardTicket(id: number) {
    return this.http.post<StatusDetails>(
      `${environment.apiUrls.tickets}/${this.name}/${id}/forward`,
      {}
    );
  }

  cancelDraftTicket(id: number) {
    return this.http.post<StatusDetails>(
      `${environment.apiUrls.tickets}/${this.name}/${id}/cancel`,
      {}
    );
  }

  upload(ticketsFile: UploadRv) {
    var formData = new FormData();
    formData.append("fileBase64", ticketsFile.fileBase64);

    return this.http.post(
      `${environment.apiUrls.files}/file-upload/${this.name}`,
      formData
    );
  }
}
